import styled, { css } from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";

import { largeScreen } from "../../constants/screenSizes";

// TODO: Possibly move this to the component library in the future
export const Tabset = styled.ul`
  display: flex;
  list-style: none;

  ${({ isResponsive }) =>
    isResponsive &&
    css`
      @media screen and (max-width: ${largeScreen}px) {
        padding-top: 10px;
      }
    `}
`;

Tabset.defaultProps = {
  isResponsive: true
};

export const Tab = styled.li`
  border: 1px solid ${colors.foxGrey};
  border-radius: 0;
  cursor: pointer;
  font-size: 14px;
  line-height: 40px;
  padding: 0 15px;
  text-align: center;
  transition: background 250ms ease;
  white-space: nowrap;

  ${({ highlighted }) =>
    highlighted &&
    css`
      background-color: ${colors.mouseGrey};
      font-weight: bold;
    `};

  & + & {
    margin-left: -1px;
  }
`;
